__turbopack_context__.v({
  "expandCollapseBtn": "expandCell-module-scss-module__EbMRuq__expandCollapseBtn",
});
